var render, staticRenderFns
import script from "./Badge.js?vue&type=script&lang=js&"
export * from "./Badge.js?vue&type=script&lang=js&"
import style0 from "./Badge.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports